export const white = "#fff";
export const black = "#000";
export const docketDarkBlue = "#000C22";
export const docketDarkBlue2 = "#001523";
export const docketDarkBlue3 = "#00233A";
export const docketDarkBlue4 = "#0b3f65";
export const docketDarkBlue5 = "#003258";
export const docketDarkBlue6 = "#003258";
export const docketDarkBlue7 = "#000508";
export const docketDarkBlue8 = "#002D4A";
export const docketDarkBlue9 = "#003F67";
export const docketDarkBlue10 = "#005A93";
export const docketDarkBlue11 = "#093a5c";
export const docketDarkBlue12 = "#0069B2";
export const docketDarkBlue13 = "#002A48";
export const docketDarkBlue14 = "#001b2c";
export const docketDarkBlue15 = "#003d64";
export const docketDarkBlue16 = "#005898";
export const docketDarkBlue17 = "#1A72B2";
export const docketDarkBlue18 = "#005286";
export const docketDarkBlue19 = "#0068B1";
export const docketDarkBlue20 = "#08619F";
export const docketDarkBlue21 = "#0071BF";
export const docketDarkBlue22 = "#005E9F";
export const docketDarkBlue23 = "#005691";
export const docketDarkBlue24 = "#00538D";
export const docketDarkBlue25 = "#012D4A";
export const docketDarkBlue26 = "#0063B6";
export const docketDarkBlue27 = "#015284";
export const docketDarkBlue28 = "#0268B1";
export const docketDarkBlue29 = "#003a61";
export const docketLightBlue = "#004672";
export const docketLightBlue2 = "#003557";
export const docketLightBlue3 = "#004774";
export const docketLightBlue4 = "#86cdff";
export const docketLightBlue5 = "#A8D3F1";
export const docketLightBlue6 = "#8AA3B4";
export const docketLightBlue7 = "#004F81";
export const docketLightBlue8 = "#0E78C3";
export const docketLightBlue9 = "#DADEE0";
export const docketLightBlue10 = "#91d1fd";
export const docketLightBlue11 = "#39adfd";
export const docketLightBlue12 = "#327EC6";
export const docketLightBlue13 = "#3697C3";
export const docketLightBlue14 = "#2393e1";
export const docketLightBlue15 = "#E5EFF7";
export const docketLightBlue16 = "#607D8B";
export const docketLightBlue17 = "#B0BEC5";
export const docketLightBlue18 = "#E5F2FD";
export const docketLightBlue19 = "#E1F1FF";
export const docketLightBlue20 = "#D2E9FF";
export const docketSkyBlue = "#90CAF9";
export const docketSkyBlue2 = "#BBDEFB";
export const docketSkyBlue3 = "#EAF5FD";
export const docketSkyBlue4 = "#DBEFFD";
export const docketSkyBlue5 = "#6CBEF7";
export const docketSkyBlue6 = "#92D4EE";
export const docketLightishBlue = "#2C95DE";
export const docketLightishBlue2 = "#86C9F8";
export const docketLightishBlue3 = "rgba(44,149,222, 0.47)";
export const docketLightishBlue4 = "#3ba4ed";
export const docketLightishBlue5 = "#48aef5";
export const docketLightishBlue6 = "#0871BA";
export const docketLightishBlue7 = "#005184";
export const docketLightishBlue8 = "#55a9e4";
export const docketLightishBlue9 = "#80bfeb";
export const docketLightishBlue10 = "#abd5f2";
export const docketLightishBlue11 = "#9ed6fc";
export const docketLightishBlue12 = "#069BFF";
export const docketRed = "#FB684C";
export const docketRed3 = "#F44336";
export const docketRed5 = "#F24A3C";
export const docketRed6 = "#FF4E5F";
export const docketRed7 = "#DB4D58";
export const docketRed8 = "#FFE5E5";
export const docketRed9 = "#F42D40";
export const docketRed10 = "#FF0000";
export const docketRed11 = "#F54858";
export const docketRed12 = "#f78690";
export const docketLightPurple = "#9FA8DA";
export const docketLightPurple2 = "#C5CAE9";
export const docketLightGreen = "#A5D6A7";
export const docketLightGreen2 = "#C8E6C9";
export const docketLightGreen3 = "#15B980";
export const docketLightGreen4 = "#2FD39A";
export const docketLightGreen5 = "#00864D";
export const docketLightGreen6 = "#16B980";
export const docketLightTeal = "#80CBC4";
export const docketLightTeal2 = "#B2DFDB";
export const docketLightTeal5 = "#3BD3D9";
export const docketLightTeal3 = "#21b9bf";
export const docketLightTeal4 = "#08A0A6";
export const docketLightTeal6 = "#00868C";
export const docketLightTeal7 = "#3BAFBF";
export const docketYellow = "#FFC108";
export const docketYellow2 = "#F4C04E";
export const docketYellow3 = "#FFF79D";
export const docketYellow4 = "#FFC16E";
export const docketYellow5 = "#FF9D00";
export const docketYellow6 = "#F29000";
export const docketOrange = "#FF955D";
export const docketGrey = "#DEDEDE";
export const docketLightGrey = "#95989A";
export const docketLightGrey2 = "#F3F3F3";
export const docketLightGrey3 = "#FAFAFA";
export const docketLightGrey4 = "#EDEDED";
export const docketLightGrey5 = "#CBCBCB";
export const docketLightGrey6 = "rgba(0, 0, 0, .26)";
export const docketLightGrey7 = "#7D7D7D";
export const docketLightGrey8 = "#BDBDBD";
export const docketLightGrey9 = "#EBEBEB";
export const docketLightGrey10 = "#E3E3E3";
export const docketLightGrey11 = "#ADADAD";
export const docketLightGrey12 = "#EAEAEA";
export const docketLightGrey13 = "#F8F9FC";
export const docketLightGrey14 = "#CCCCCC";
export const docketLightGrey15 = "#e0e0e0";
export const docketLightGrey16 = "#F2F2F2";
export const docketLightGrey17 = "#F0F0F0";
export const docketLightGrey18 = "#D7D7D7";
export const docketLightGrey20 = "#EBEBEB";
export const docketLightGrey21 = "#EFEFEF";
export const docketLightGrey22 = "rgb(222, 222, 222)";
export const docketLightGrey23 = "#E1E1E1";
export const docketLightGrey24 = "#A8A8A8";
export const docketLightGrey25 = "rgba(136,136,136,0.44)";
export const docketLightGrey26 = "rgba(60,60,60,0.77)";
export const docketLightGrey27 = "#D9D9D9";
export const docketLightGrey28 = "#F6F6F6";
export const docketLightGrey29 = "#AAAAAA";
export const docketLightGrey30 = "#B9B9B9";
export const docketLightGrey31 = "#E2E2E2";
export const docketLightGrey32 = "#707070";
export const docketLightGrey33 = "#D6D6D6";
export const docketLightGrey34 = "#D1D1D1";
export const docketLightGrey35 = "#F7F7F7";
export const docketLightGrey36 = "#EEEEEE";
export const docketLightGrey37 = "#A1A1A1";
export const docketLightGrey38 = "#e7e7e7";
export const docketLightGrey39 = "#f1f1f1";
export const docketLightGrey40 = "#8D8D8D";
export const docketTealGreen = "#5BABB5";
export const docketTealGreen2 = "#A3DFD9";
export const docketTealGreen3 = "#1FB59C";
export const textLightGrey = "rgba(0, 0, 0, 0.38)";
export const docketDarkerGrey = "#515151";
export const textDocketBlue = "rgba(44, 149, 222, 0.54)";
export const textDocketDarkBlue = "rgba(44, 149, 222, 0.87)";
export const textGrey = "rgba(0, 0, 0, 0.54)";
export const textDarkGrey = "#929292";
export const textDarkGrey2 = "#757575";
export const textDarkGrey3 = "rgba(0, 0, 0, 0.87)";
export const textDarkGrey4 = "rgba(0, 0, 0, 0.36)";
export const textDarkGrey5 = "rgba(0, 0, 0, 0.56)";
export const textDarkGrey6 = "#999999";
export const textDarkGrey7 = "#6E6E6E";
export const textDarkGrey8 = "#444546";
export const textDarkGrey9 = "#222222";
export const textDarkGrey10 = "#4D4D4D";
export const textDarkGrey11 = "rgb(114, 114, 114)";
export const textDarkGrey12 = "#333333";
export const textDarkGrey16 = "#575757";
export const textDarkGrey17 = "#313131";
export const transparentBlack = "#D5D5D5";
export const transparentBlack2 = "rgba(0, 0, 0, 0.9)";
export const transparentBlack3 = "rgba(0, 0, 0, 0.7)";
export const transparentBlack4 = "rgba(0, 0, 0, 0.8)";
export const transparentBlack5 = "rgba(0, 0, 0, 0.16)";
export const transparentBlack6 = "rgba(0, 0, 0, 0.12)";
export const transparentBlack7 = "rgba(0, 0, 0, 0.06)";
export const transparentBlack8 = "rgba(0, 0, 0, 0.3)";
export const transparentBlack9 = "rgba(0, 0, 0, 0)";
export const docketDarkGrey = "rgba(#010101, 0.54)";
export const docketDarkGrey2 = "#424242";
export const docketDarkGrey3 = "rgba(0, 0, 0, 0.53)";
export const docketDarkGrey4 = "#777777";
export const docketDarkGrey5 = "#010101";
export const docketDarkGrey6 = "#808080";
export const docketDarkGrey7 = "#A3A3A3";
export const docketDarkGrey8 = "#00253c";
export const docketDarkGrey9 = "#5E5E5E";
export const docketDarkGrey10 = "#666666";
export const docketDarkGrey11 = "#727272";
export const docketDarkGrey12 = "#484848";
export const docketGreyAlpha1 = "rgba(153, 153, 153, 0.2)";
export const docketDarkGrey13 = "#888888";
export const docketDarkGrey14 = "#3C3C3C";
export const docketDarkGrey15 = "#555555";
export const docketDarkGrey16 = "#7C7C7C";
export const docketDarkGrey17 = "#ACACAC";
export const docketDarkGrey18 = "#282828";
export const docketDarkGrey19 = "#3B3B3B";
export const backgroundGrey = "rgba(0, 0, 0, 0.02)";
export const opaqueWhite = "rgba(255, 255, 255, 0.91)";
export const halfOpaqueWhite = "rgba(255, 255, 255, 0.56)";
export const graphGreen = "#80C883";
export const graphRed = "#E67374";
export const graphGrey = "#90A4AF";
export const graphLightGrey = "#D3D3D3";
export const docketGold = "#FFAF00";
export const transparent = "transparent";
export const hoverBlue = "#0E6DCD";
export const linkBlue = "#1677FF";
export const menuBG = "#F7F9FB"
export const menuLightBlue = "#E6F4FF"